var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"filter bg_fff pl15 pr15 pt10 pb10 flex"},_vm._l((_vm.filter),function(data,index){return _c('li',{staticClass:"fs12 mr10 bg_eee pl10 pr10 pt5 pb5 radius20",class:{cover:index===_vm.curr},on:{"click":function($event){return _vm.handler(index,data)}}},[_vm._v(_vm._s(data.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-23fcfa56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/doc/comment/filter.vue
// module id = 1441
// module chunks = 382